import { FC } from 'react'
import { useSelector } from 'react-redux'

import MeasureController from 'core/analytics/MeasureController'
import { PlanAchievement } from 'partner360/components/QBR/components/qbrDocumentDetails/components/steps/planAchievement/PlanAchievement'
import { QbrSobCompetitors } from 'partner360/components/QBR/components/qbrDocumentDetails/components/steps/qbrSobCompetitors/QbrSobCompetitors'
import { SobAchievement } from 'partner360/components/QBR/components/qbrDocumentDetails/components/steps/sobAchievement/SobAchievement'
import { hasSobCompetitorsStep } from 'partner360/components/QBR/helpers/hasSobCompetitorsStep'
import { selectQBROfferings, selectQBRPartners } from 'partner360/features/QBR'

import { QBRSectionThatCanBeDisabled } from '../../../../shared/qbrSectionThatCanBeDisabled/QBRSectionThatCanBeDisabled'
import { DocumentAtGlance } from '../steps/documentAtGlance/DocumentAtGlance'
import { ExportAndAttachments } from '../steps/exportAndAttachments'
import { Initiatives } from '../steps/initiatives/Initiatives'
import { SettingsStep } from '../steps/settingsStep/SettingsStep'

import { DataValidityPanel } from './components/dataValidityPanel/DataValidityPanel'

interface IQbrDocumentDetailsStepRenderProps {
  currentStep: number
  widgetParams: IObjectAny
  metrics: MeasureController
  showListOfAllDocuments: () => void
}

export const QbrDocumentDetailsStepRender: FC<IQbrDocumentDetailsStepRenderProps> = ({
  currentStep,
  metrics,
  widgetParams,
  showListOfAllDocuments,
}) => {
  const qbrOfferings = useSelector(selectQBROfferings)
  const qbrPartners = useSelector(selectQBRPartners)
  const hasCompetitors = hasSobCompetitorsStep(qbrPartners, qbrOfferings)

  switch (currentStep) {
    case 1: {
      return (
        <QBRSectionThatCanBeDisabled>
          <SettingsStep showListOfAllDocuments={showListOfAllDocuments} />
        </QBRSectionThatCanBeDisabled>
      )
    }
    case 2: {
      return (
        <QBRSectionThatCanBeDisabled>
          <DataValidityPanel />
          <DocumentAtGlance widgetParams={widgetParams} metrics={metrics} />
        </QBRSectionThatCanBeDisabled>
      )
    }
    case 3: {
      return (
        <QBRSectionThatCanBeDisabled>
          <DataValidityPanel />
          <PlanAchievement />
        </QBRSectionThatCanBeDisabled>
      )
    }
    case 4: {
      return (
        <QBRSectionThatCanBeDisabled>
          <DataValidityPanel />
          <SobAchievement />
        </QBRSectionThatCanBeDisabled>
      )
    }
    case 5: {
      return (
        <QBRSectionThatCanBeDisabled>
          <DataValidityPanel />
          <Initiatives />
        </QBRSectionThatCanBeDisabled>
      )
    }
    case 6:
      return (
        <>
          <DataValidityPanel />
          {hasCompetitors ? <QbrSobCompetitors /> : <ExportAndAttachments />}
        </>
      )

    case 7:
      return (
        <>
          <DataValidityPanel />
          <ExportAndAttachments />
        </>
      )
    default: {
      return <div> not found</div>
    }
  }
}
